<template>
  <div class="meter">
    <div class="meter-value" :style="{ width: valuePrc }"></div>
    <span>
      <slot></slot>
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    value: {
      required: true,
      type: Number,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
})
export default class AudioMeter extends Vue {
  value!: number;
  max!: number;
  min!: number;

  get valuePrc() {
    let prc = Math.round(
      (100 * (this.value - this.min)) / (this.max - this.min)
    );
    if (prc < 0) prc = 0;
    if (prc > 100) prc = 100;
    return `${100 - prc}%`;
  }
}
</script>

<style lang="scss">
.meter {
  width: 100%;
  border: 1px solid #ddd;
  padding: 1px 2px;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  text-overflow: ellipsis;
  position: relative;
  text-shadow: 1px 0 0 white, -1px 0 0 white, 0 -1px 0 white, 0 1px 0 white;
  background: linear-gradient(
    90deg,
    rgb(32, 150, 70) 0%,
    rgb(32, 190, 70) 80%,
    rgb(255, 225, 59) 90%,
    rgb(198, 25, 25) 100%
  );
  span {
    position: relative;
    user-select: auto;
  }
  .meter-value {
    box-sizing: inherit;
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    background: rgb(92, 192, 92);
    background: #fcfcfc;
  }
}
</style>
